import { API_HOST, getHttpGetOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/message`;

const getCreateMessageEndpoint = () => `${getEndpoint()}/create`;
export const getCreateMessageRequest = (message) => [getCreateMessageEndpoint(), getHttpPostOptions(message)];

const getViewAllChatsEndpoint = (personExternalReference) => `${getEndpoint()}/view/${personExternalReference}`;
export const getViewAllChatsRequest = (personExternalReference) => [
  getViewAllChatsEndpoint(personExternalReference),
  getHttpGetOptions(),
];

const getViewChatEndpoint = (personExternalReference, chatExternalReference) =>
  `${getEndpoint()}/retrieve/${chatExternalReference}/${personExternalReference}`;
export const getViewChatRequest = (personExternalReference, chatExternalReference) => [
  getViewChatEndpoint(personExternalReference, chatExternalReference),
  getHttpGetOptions(),
];

const getViewSupportChatEndpoint = (personExternalReference) =>
  `${getEndpoint()}/view/support/${personExternalReference}`;
export const getViewSupportChatRequest = (personExternalReference) => [
  getViewSupportChatEndpoint(personExternalReference),
  getHttpGetOptions(),
];

const getCreateSupportMessageEndpoint = () => `${getEndpoint()}/create/support-message`;
export const getCreateSupportMessageRequest = (message) => [
  getCreateSupportMessageEndpoint(),
  getHttpPostOptions(message),
];

const getViewAllSupportChatsEndpoint = () => `${getEndpoint()}/view/admin/support`;
export const getViewAllSupportChatsRequest = () => [getViewAllSupportChatsEndpoint(), getHttpGetOptions()];
